import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
// import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import Img from "../../images/logo 01.png";
import Avatar from "@mui/material/Avatar";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avtr from "../../images/avatar.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { mainListItems, secondaryListItems } from "./listItems";
import Deposits from "./Deposits";
import Orders from "./Orders";
import SearchBox from "./searchbox";
import DashImg1 from "../../images/dash3.png";
import DashImg3 from "../../images/dash1.png";
import DashImg2 from "../../images/dash2.png";
import Deposits2 from "./deposits2";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useNavigate } from "react-router-dom";
import { setAuthToken } from "../../utils/setAuthToken";
import NotificationMenu from "./notification";
import DashboardDrawer from "../drawer/drawer";
const settings = ["Profile", "Wallet", "Dashboard", "Logout"];

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
export default function Dashboard() {
  const [open, setOpen] = React.useState(true);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const handleMainLogoClick = () => {
    navigate("/");
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  // Backdrop usestates and functions
  const [openbackdrop, setOpenbackdrop] = React.useState(false);
  const handleClose = () => {
    setOpenbackdrop(false);
  };
  const handleOpen = () => {
    setOpenbackdrop(true);
  };
  //use States
  const [transaction, setTransaction] = React.useState("");
  const [customer, setCustomer] = React.useState("");
  const getAllTransaction = (e) => {
    console.log("haha dashboard");

    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .post("https://api.blockpay.co.za/blockchain/getAllTransaction", {
        limited: true,
      })
      .then((res) => {
        console.log(res);
        setTransaction(res.data.totalTransactionCount);
        setCustomer(res.data.uniqueUsers);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };

  const navigate = useNavigate();
  const handleNavigation = (setting) => {
    // Navigate to the appropriate route based on the clicked setting
    if (setting === "Profile") {
      navigate("/setting", { replace: true });
    } else if (setting === "Wallet") {
      navigate("/wallet", { replace: true });
    } else if (setting === "Dashboard") {
      navigate("/dashboard", { replace: true });
    } else if (setting === "Logout") {
      localStorage.clear();
      window.location.reload();
    }
  };

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 600) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }
    window.addEventListener("resize", handleResize);

    handleOpen();
    getAllTransaction();
    setTimeout(() => {
      handleClose();
    }, 2000);
  }, []);
  return (
    <ThemeProvider theme={defaultTheme}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          position="absolute"
          open={open}
        >
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: "36px",
                color: "black",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="body1"
              color="inherit"
              noWrap
              sx={{
                flexGrow: 1,
                textAlign: "left",
                color: "black",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              <span>Welcome {localStorage.getItem("name")}!</span>
              <Typography
                component="h1"
                variant="caption"
                color="inherit"
                noWrap
                sx={{
                  flexGrow: 1,
                  textAlign: "left",
                  color: "grey",
                  fontSize: "12px",
                  position: "relative",
                  top: "-0.3rem",
                }}
              >
                Hope you are healthy and happy today...
              </Typography>
            </Typography>
            <Box sx={{ display: "flex" }}>
              <SearchBox />
              {/* //Notification Dialog code */}
              <NotificationMenu />

              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt="Remy Sharp" src={Avtr} />
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting) => (
                    <MenuItem
                      key={setting}
                      onClick={() => handleNavigation(setting)}
                    >
                      <Typography textAlign="center">{setting}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <DashboardDrawer />
        <Drawer
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          variant="permanent"
          open={open}
        >
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: [1],
            }}
          >
            <Box
              component="img"
              sx={{
                height: "38px",
              }}
              alt="The house from the offer."
              style={{ cursor: "pointer" }}
              onClick={handleMainLogoClick}
              src={Img}
            />
          </Toolbar>
          <Divider />
          <List component="nav">
            {mainListItems}
            <Divider sx={{ my: 1 }} />
            {secondaryListItems}
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: "#F5F5F5",
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="false" sx={{ padding: "0!important" }}>
            <Grid
              container
              spacing={2}
              sx={{
                backgroundColor: "#111111",
                pt: "37px",
                px: "24px",
                pb: "31px",
              }}
            >
              {/* Chart */}
              <Grid item xs={12} md={6} lg={4}>
                <Paper
                  sx={{
                    p: "25px",
                    display: "flex",
                    flexDirection: "column",
                    height: "fit-content",
                    background: "#4E4E4E1A",
                    border: "1px solid #4E4E4E",
                    borderRadius: "20px",
                  }}
                >
                  <Deposits
                    data="Available Balance"
                    num="R 49,999.99"
                    img={DashImg1}
                  />
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              <Grid item xs={12} md={6} lg={4}>
                <Paper
                  sx={{
                    p: "25px",
                    display: "flex",
                    flexDirection: "column",
                    height: "fit-content",
                    background: "#4E4E4E1A",
                    border: "1px solid #4E4E4E",
                    borderRadius: "20px",
                  }}
                >
                  <Deposits2
                    data="Total Transaction"
                    num={transaction}
                    img={DashImg2}
                  />
                </Paper>
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <Paper
                  sx={{
                    p: "25px",
                    display: "flex",
                    flexDirection: "column",
                    height: "fit-content",
                    background: "#4E4E4E1A",
                    border: "1px solid #4E4E4E",
                    borderRadius: "20px",
                  }}
                >
                  <Deposits2
                    data="Total Customer"
                    num={customer}
                    img={DashImg3}
                  />
                </Paper>
              </Grid>
              {/* Recent Orders */}
            </Grid>
            <Grid item xs={12}>
              <Paper
                sx={{
                  px: "25px",
                  pt: "20px",
                  paddingBottom: "16px",
                  margin: "28px 24px 28px",
                  overflow: "hidden",
                }}
              >
                <Orders />
              </Paper>
            </Grid>
            {/* <Copyright sx={{ pt: 4 }} /> */}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
